import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cancelMembership, getMyMebershipDetails } from "../../../redux/membership/action";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { getDateFormate } from "../../Common/AllDateTimeReleventFormate";
import PostNotFound from "../../CustomComponents/AllLoader/PostNotFound";
import { IS_TEST_MODE } from "../../../assests/extention/commonfunction";

export default function Membership() {
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/membership.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mem = useSelector(
    ({ membership: { mymebershipdetails } }) => mymebershipdetails,
  );
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  useEffect(() => {
    dispatch(getMyMebershipDetails());
  }, []);

  const cancelMembe = (id) => {
    const data = {
      id: id,
      "cancle": "1"
    };
    dispatch(cancelMembership(data));
  }

  const mem_length = (Array.isArray(mem?.memberships) && mem?.memberships?.length) || 0

  const getMembershipType = (type) => {
  let type_name = "";

  if (type === 1) type_name = "Local Plan";
  else if (type === 2) type_name = "Global Plan";
  else if (type === 3) type_name = "Regional Plan";
  else type_name = "Unknown Plan";

  return type_name;
};

  return (
    <div className ="membership">
      <div className ="membership-first">
        <div>
          <h2 className ="font-42">Membership</h2>
          <h6>Manage and upgrade your active membership</h6>
        </div>
        <div className ="memebership-button">
          <button
            type="button"
            onClick={() => navigate(`/${lan}/account/upgrademembership`)}
            className ="next-button"
          >
            {mem_length > 0 ? 'Upgrade Membership' : 'Buy Membership'}
          </button>
        </div>
      </div>
      {Array.isArray(mem?.memberships) && mem?.memberships?.map((item, index) => (
        <>
        <div className ="active-membership" style={{ marginTop: 10 }}>
          <div className ="col-md-9 p-0" key={index}>
            <h2>Active membership ({getMembershipType(item?.membership_type)})</h2>
            <div className ="row">
              <div className ="col-md-3">
                <p>Membership name</p>
                <h6>{item?.title} </h6>
              </div>
              <div className ="col-md-3">
                <p>Amount</p>
                <h6>${item?.price}/{item?.duration_type == 1
                  ? "Hour"
                  : item?.duration_type == 2
                    ? "Days"
                    : item?.duration_type == 3
                      ? "Weeks"
                      : item?.duration_type == 4
                        ? "Months"
                        : ""} </h6>
              </div>
              <div className ="col-md-3">
                <p>Purchased date</p>
                <h6>{getDateFormate(item?.created_on)} </h6>
              </div>
               {/* <div className ="col-md-3">
                <p>Membership Type</p>
                
              </div> */}
              <div className ="col-md-3">
                <p>Next billing date</p>
                <h6>{getDateFormate(item?.ends_on)}  </h6>
              </div>
            </div>
          </div>

          {/* <button onClick={() => cancelMembe(item?.id)} className ="btn cancel-membership">Cancel Membership</button> */}
        </div>
        {(Array.isArray(item?.services) && item?.services?.length > 0) ?
        <div className ="membership-utilisation">
          <h4>Membership Utilisation</h4>
          <div className ="table-responsive">
            <table className ="table">
              {/* {JSON.stringify()} */}
              <thead>
                <tr>
                  <th>Included service</th>
                  <th>Included</th>
                  <th>Used</th>
                  <th>Available</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(item?.services) && item?.services?.map((item, index) => (
                  <tr key={index}>
                    <td>{`${item?.services} (${item?.sub_services})`}</td>
                    <td>{item?.quantity}</td>
                    <td>{item?.used}</td>
                    <td>{item?.available}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        :
        <PostNotFound title={"No Active Membership"} />
      }
      </>
      ))}

      {/* {(Array.isArray(mem?.services) && mem?.services?.length > 0) ?
        <div className ="membership-utilisation">
          <h4>Membership Utilisation</h4>
          <div className ="table-responsive">
            <table className ="table">
              <thead>
                <tr>
                  <th>Included service</th>
                  <th>Included</th>
                  <th>Used</th>
                  <th>Available</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(mem?.services) && mem?.services?.map((item, index) => (
                  <tr key={index}>
                    <td>{`${item?.services} (${item?.sub_services})`}</td>
                    <td>{item?.quantity}</td>
                    <td>{item?.used}</td>
                    <td>{item?.available}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        :
        <PostNotFound title={"No Active Membership"} />
      } */}
    </div>
  );
}
